import { CodeBox } from "@alch/ui";
import type { Control } from "react-hook-form";
import { useWatch } from "react-hook-form";

import type { NetworkInfo } from "@alch/dx-entities/index";
import {
  buildComposerRequestBody,
  buildComposerRequestUrl,
} from "@features/composer/lib/request";
import type { ComposerFormState } from "./lib/form.js";
import type { ComposerMethodConfig } from "./lib/methods.js";

interface ComposerRequestPreviewProps {
  className?: string;
  control: Control<ComposerFormState>;
  methodConfig: ComposerMethodConfig;
  networkInfo?: NetworkInfo;
}

const ComposerRequestPreview = ({
  className,
  control,
  methodConfig,
  networkInfo,
}: ComposerRequestPreviewProps) => {
  const query = useWatch({ control, name: "query" });
  const body = useWatch({ control, name: "body" }) as unknown;

  return (
    <CodeBox
      className={className}
      title="Request"
      snippets={[
        {
          wrapLongLines: true,
          language: methodConfig.requestBody ? "json" : "python",
          code: methodConfig.requestBody
            ? buildComposerRequestBody({ methodConfig, body })
            : buildComposerRequestUrl({
                methodConfig,
                query,
                networkInfo,
                apiKey: "{apiKey}", // mask api key in preview
              }),
        },
      ]}
    />
  );
};

export default ComposerRequestPreview;
